/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Main.vue?vue&type=template&id=329a42c8&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"
import style0 from "./Main.vue?vue&type=style&index=0&id=329a42c8&lang=scss"
import style1 from "./Main.vue?vue&type=style&index=1&id=329a42c8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "329a42c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src686490483/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('329a42c8')) {
      api.createRecord('329a42c8', component.options)
    } else {
      api.reload('329a42c8', component.options)
    }
    module.hot.accept("./Main.vue?vue&type=template&id=329a42c8&scoped=true", function () {
      api.rerender('329a42c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/tables/partials/Main.vue"
export default component.exports